<div class="w100 flex-center-center flex-direction-column">
  <button mat-flat-button [color]="color" (click)="openDialog(DialogComponent)" type="button">
    {{'elementParse.title'|translate}}&nbsp;
    @if (value$|async; as value) {
      @if (value.noTraduction) {
        {{value.noTraduction}}
      } @else {
        {{value.traduction!|translate}}
      }
    }
  </button>
</div>

<ng-template #DialogComponent>
  <mat-dialog-content>
    <form [formGroup]="form" class="width-container-filter flex-direction-column flex-center-center">
      <div class="flex-direction-row flex-center-center">
        <div class="form-field-filter">
          <mat-form-field appearance="outline" class="w100">
            <mat-label>{{'name'|translate}}</mat-label>
            <input matInput formControlName="filterName">
            <button mat-icon-button matPrefix (click)="$event.stopPropagation();unsetValue('filterName')">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-form-field>
        </div>
        @if (possibleValues|transformValueByPredicateFunction:getPossibleValuesPredicate; as pValuesDataForm) {
          <div class="form-field-filter"
            >
            <mat-form-field appearance="outline" class="w100">
              <mat-label>{{'elementParse.environment'|translate}}</mat-label>
              <mat-select formControlName="filterEnvironment">
                @for (possibleValue of pValuesDataForm!; track possibleValue) {
                  <mat-option
                  [value]="possibleValue.valueForm">{{possibleValue.traduction ? (possibleValue.traduction|translate) : possibleValue.html}}</mat-option>
                }
              </mat-select>
              <button mat-icon-button matPrefix
                (click)="$event.stopPropagation();unsetValue('filterEnvironment')">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-form-field>
          </div>
        }
        <div>
          <mat-checkbox formControlName="includeUsedElement">{{'includeUsedElement'|translate}}</mat-checkbox>
        </div>
      </div>
      <div>
        <mat-selection-list [multiple]="false" formControlName="selectValue">
          @for (element of possibleValues|transformValueByPredicateFunction:filterFunctionPredicate:(filterName$|async):(filterEnvironment$|async):(includeUsedElement$|async):idsUsed; track element) {
            <mat-list-option
              [value]="element.objectId" style="height: unset">
              <ng-container
                [ngTemplateOutlet]="BOXELEMENT"
                [ngTemplateOutletContext]="element"
                >
              </ng-container>
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
    </form>
  </mat-dialog-content>
  <div mat-dialog-actions>
    <button mat-flat-button [mat-dialog-close]="undefined" color="accent">
      {{'close'|translate}}
    </button>
    <button mat-flat-button [mat-dialog-close]="true" color="primary">
      {{'elementParse.substitution'|translate}}
    </button>
  </div>
</ng-template>

<ng-template #BOXELEMENT let-name=name let-environment=environment let-room=room let-floor=floor>
  <span matListItemTitle>{{name}}</span>
  <span matListItemLine>{{environment}}</span>
  <span>
    {{'elementParse.floor'|translate}}:&nbsp;
    <span style="font-weight: bold">
      @if (floor!='NONE') {
        {{floor}}
      } @else {
        {{'other'|translate}}
      }
    </span>
    ,
  </span>
  <span>
    {{'elementParse.room'|translate}}:&nbsp;
    <span style="font-weight: bold">
      @if (room!='NONE') {
        {{room}}
      } @else {
        {{'other'|translate}}
      }
    </span>
  </span>
  <mat-divider style="margin-bottom: 5px"></mat-divider>
</ng-template>
